import type { ComponentProps } from "react"
import { forwardRef } from "react"

import { cn } from "@productlane/lib/src/browser"

type Props = ComponentProps<"svg">

export const PlainLogo = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				version="1.0"
				width="70pt"
				height="70pt"
				viewBox="0 0 700.000000 700.000000"
				preserveAspectRatio="xMidYMid meet"
				ref={ref}
				{...props}
				className={cn("", className)}
			>
				<g
					transform="translate(0.000000,700.000000) scale(0.100000,-0.100000)"
					className="fill-black dark:fill-white"
					stroke="none"
				>
					<path d="M1510 3495 l0 -1995 378 2 377 3 3 723 2 723 538 -2 c513 -1 541 -1 639 20 262 55 474 165 657 341 119 115 195 219 266 364 337 689 -17 1502 -762 1750 -199 67 -185 66 -1190 66 l-908 0 0 -1995z m2050 720 l0 -625 -645 0 -645 0 0 625 0 625 645 0 645 0 0 -625z" />
					<path d="M4557 2423 c-4 -3 -7 -210 -7 -460 l0 -453 470 0 470 0 0 460 0 460 -463 0 c-255 0 -467 -3 -470 -7z" />
				</g>
			</svg>
		)
	},
)
